export const MDU_API_CONSTANTS = {
    GET_PROPERTIES_LIST: '/mdu/properties',
    UPLOAD_PROPERTY_LIST: '/uploadMduData',
    // UPLOAD_TECHNICIAN_LIST: '/uploadTechnicianData',
    GET_SEARCH_LIST: '/mdu/search',
    GET_TECHNICIAN_PROPERTIES: '/mdu/technicianProperties',

};
